<template>
  <b-modal id="call-op" title="Seleccione op para agregar a la lista" @show="getOpList" @ok="handleOk">
    <b-form-group label="OP" label-for="op" v-if="ready">
      <b-form-select
        id="op"
        v-model="selectedOp"
        :options="opOptions"
        value-field="id"
        text-field="id"
        :disabled="opOptions.length === 0"
      ></b-form-select>
    </b-form-group>
  </b-modal>
</template>

<script>
export default {
  name: "CallOpModal",
  data() {
    return {
      ready: false,
      selectedOp: null,
      opOptions: []
    };
  },
  props: {
    id: {
      type: String,
      default: "call-op-modal"
    },
    items: {
      type: Array,
      default: () => []
    }
  },
  methods: {
    handleOk() {
      const selected = this.opOptions.find((op) => op.id === this.selectedOp);
      this.$emit("ok", selected);
    },
    async getOpList() {
      try {
        const response = await this.$axios.get(
          `/api/v1/purchase_order/?no_page&fields=id,delivery_date,kilograms,progress,container,quantity,completed_boxes,remaining_boxes,plan&expand=container,plan.market`
        );
        this.opOptions = response.data.filter((op) => !this.items.map((item) => item.id).includes(op.id));
      } catch (error) {
        console.log(error);
      } finally {
        this.ready = true;
      }
    }
  }
};
</script>

<style></style>
